module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABTElEQVRYR+2WsVKDQBCG/+3A94I8QWy00MY0WsTAaKOFNnEgWmhjmlhoo08QeC+hW+cygTkvyXFn4aaAEm53v/9nb+8Iwg8J10cP0DvQ6UAYzYZVOfn6S7O6xFoBVAIQfzJwXBfJhw9EEOdHBLyD6dAmYCdAU7wpykyndTl5c4EIotkJES/atRYIqwOtinUmAkbfRTK3QRzE+RkDry14h3udPbChhviiWqYv2yDCQXYOpmcf1zoBVDJTFYDLqkiedIgwzscAHpt3Lm6ptU4AaqGpDsTX1TJ9WH+7AtO0BbK4ZDrnDLAqZKhk5tuVCqI7LfGGO7ae8QLYqlbPrrnislu8foGeMIiyG0M1lBt1md67FtZ6xTcEEAUIB9nvhvvPXyDahKLbUHQQiY5i0cNoL45j0QtJs71drlW7RplLrPdZ4D837RE9QO+AuAM/yTXgIdkYe38AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/close.png
// module id = YRdU
// module chunks = 1